import { render, staticRenderFns } from "./VSyncSelect.vue?vue&type=template&id=16132995"
import script from "./VSyncSelect.vue?vue&type=script&lang=js"
export * from "./VSyncSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports